const MHSF_PRODUCTDETAIL_KEY = 'mhsfProductDetail';
const sessionStorageKey = 'forceFmsPopup';
const instoreDisclaimerStorageKey = 'instoreDisclaimer';

class InStoreProductService {
    constructor($state, Restangular, sessionStorageWrapper, detailProductService, shopperService, trolleyService, loginService, $location) {
        this.$location = $location;
        this.$state = $state;
        this.api = Restangular.all('products');
        this.sessionStorage = sessionStorageWrapper;
        this.detailProductService = detailProductService;
        this.shopperService = shopperService;
        this.trolleyService = trolleyService;
        this.loginService = loginService;
        this.showInstoreDisclaimer = false;
        this.disclaimerEnabled = false;
    }

    retrieveAndRemoveMhsfDetail() {
        return this.sessionStorage.getJsonAndRemove(MHSF_PRODUCTDETAIL_KEY);
    }

    triggerMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm, isInTrolley = false) {
        // remove MHSF params from state to prevent user from being redirect to this page after login.
        if (this.$state.params.googleshop) {
            delete this.$state.params.googleshop;
            delete this.$state.params.store_code;
            delete this.$state.params.cmpid;
        }

        if (this.shopperService.IsGuest) {
            this.loginService.promptForLogin(this.loginService.LoginToAddMoreProductsMessage, null, null, null, () => {
                this.processMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm, false, isInTrolley);
            });
        } else {
            this.$location.url(this.$location.path());
            this.$state.transitionTo(this.$state.current, this.$state.params, {
                reload: true, inherit: false, notify: true,
            });
            this.processMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm, true, isInTrolley);
        }
    }

    processMhsfProduct(instoreSalePrice, stockCode, storeCode, quantity, source, searchTerm, authenticated, isInTrolley = false) {
        if (this.shopperService.shopper.FulfilmentStoreId === storeCode || authenticated) {
            if (isInTrolley === true) {
                // if the product is already in trolley then display relevant disclaimer without performing any update
                this.showDisclaimer(stockCode, instoreSalePrice);
            } else {
                // same store - skip FMS and add product
                this.addProductToCart(stockCode, instoreSalePrice, quantity, source, searchTerm).then((didAddToCart) => {
                    if (!didAddToCart) {
                        this.enableDisclaimer();
                    }
                });
            }

            return;
        }

        // different selected store and was a guest user. Store data in session to use after FMS is complete.
        this.sessionStorage.setJson(MHSF_PRODUCTDETAIL_KEY, {
            instoreSalePrice, stockCode, quantity, source, searchTerm,
        });

        // trigger FMS.
        this.sessionStorage.set(sessionStorageKey, true);
    }

    shouldShowFMS() {
        return this.sessionStorage.getAndRemove(sessionStorageKey, true);
    }

    addSavedProductToCart() {
        const mhsfDetail = this.retrieveAndRemoveMhsfDetail();
        if (mhsfDetail) {
            this.addProductToCart(mhsfDetail.stockCode, mhsfDetail.instoreSalePrice, mhsfDetail.quantity, mhsfDetail.source, mhsfDetail.searchTerm).then((didAddToCart) => {
                if (!didAddToCart) {
                    this.enableDisclaimer();
                }
            });
        }
    }

    addProductToCart(stockCode, instoreSalePrice, quantity, source, searchTerm) {
        return this.detailProductService.getProductDetail(stockCode).then((detail) => {
            if (detail.Product.Price <= instoreSalePrice && detail.Product.IsPurchasable) {
                this.trolleyService.addItemToTrolley(detail.Product, quantity, source, searchTerm);
                return true;
            }

            return false;
        });
    }

    // puts disclaimer knowledge in storage for when this logic needs to persist the page refresh after login.
    enableDisclaimer() {
        this.sessionStorage.set(instoreDisclaimerStorageKey, true);
        this.disclaimerEnabled = true;
    }

    // to be called before using disclaimerEnabled field incase it was reset by a page refresh (by logging in)
    UpdateDisclaimer() {
        this.disclaimerEnabled = this.sessionStorage.getAndRemove(instoreDisclaimerStorageKey);
    }

    showDisclaimer(stockCode, instoreSalePrice) {
        this.detailProductService.getProductDetail(stockCode).then((detail) => {
            if (detail.Product.Price > instoreSalePrice || !detail.Product.IsPurchasable) {
                this.enableDisclaimer();
            }
        });
    }
}

InStoreProductService.$inject = ['$state', 'Restangular', 'SessionStorageWrapper', 'DetailProductService', 'ShopperService', 'TrolleyService', 'LoginService', '$location'];

module.exports = InStoreProductService;



// WEBPACK FOOTER //
// ./src/common/products/instoreproduct.service.js